<template>
<div class="manufacturer" v-on:click="click();" v-bind:class="{'selected':(is_selected)}">
	{{ info.name }}
</div>
</template>

<script>
export default {
	name: 'Manufacturer',
	props: ['info'],
	computed: {
		is_selected() {
			return this.info.selected;
		}
	},
	methods: {
		click() {
			this.$store.dispatch('toggle_manufacturer', this.info.name);
		},
	},
}
</script>

<style scoped>

div.manufacturer {
	user-select: none;
	transition:all 0.3s ease;
	line-height: 180%;
	opacity: 0.7;
}

div.manufacturer:hover {
	transform: scale(1.15);
}

div.selected {
	opacity: 1.0;
	font-weight: 900;
	color: #000;
}

</style>



// WEBPACK FOOTER //
// src/components/Manufacturer.vue